import React, { memo } from 'react'

import { Box, StencilLine } from 'stardust'
import styled from 'styled-components'

import { CHAT_BUBBLE_WIDTH, RevealElementCSS, SPACERS } from '~/theme'

const LoadingBubble = styled(Box)<{ textReveal?: boolean }>`
  width: ${CHAT_BUBBLE_WIDTH};
  max-width: 80%;
  align-self: flex-start;
  margin: ${SPACERS.xs} 0;
  ${(props) => props.textReveal && RevealElementCSS}
`

const LoadingAIBubble = () => (
  <LoadingBubble textReveal data-qa="loading-ai-bubble">
    <StencilLine width="100%" mb={2} withShimmer height="12px" />
    <StencilLine width="100%" mb={2} withShimmer height="12px" />
    <StencilLine width="50%" mb={2} withShimmer height="12px" />
    <StencilLine width="25%" withShimmer height="12px" />
  </LoadingBubble>
)
LoadingAIBubble.displayName = 'LoadingAIBubble'
export default memo(LoadingAIBubble)
